import {ObjectId} from 'bson';
import {z} from 'zod';
import {zodTypeguard} from './api/helpers';

export const ObjectIdSchema = z.instanceof(ObjectId);
export const isObjectId = zodTypeguard(ObjectIdSchema);
